import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';

import ads from 'ads/reducers';
import page from 'page/reducers';
import player from 'player/reducers';
import schedule from 'schedule/reducers';
import scheduleModule from 'scheduleModule/reducers';
import app from './appReducer';
import authentication from './authenticationReducer';
import fan from './fanReducer';
import lastAction from './lastActionReducer';
import oneId from './oneIdReducer';
import providerDialog from './providerDialogReducer';
import scoring from './scoringReducer';
import activation from './activationReducer';

const rootReducer = combineReducers({
    ads,
    app,
    authentication,
    fan,
    lastAction,
    oneId,
    page,
    player,
    providerDialog,
    routing,
    scoring,
    schedule,
    scheduleModule,
    activation
});

export default rootReducer;



// WEBPACK FOOTER //
// ./app/common/reducers/index.js